import styled, { css } from 'styled-components';
export const Container = styled.div`
  display: flex;
  width: 60rem;
  min-width:300px;
  height: 45rem;
  flex-direction: column;
  font-size: 0.90rem;
  padding: 1rem;
  ${(props) => (props.disabled &&
    css`
      pointer-events:none;
      opacity: 0.7;
    `
  )}
`
export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 1rem;
  gap: 1rem;
  /* border-radius: 4px;
  background-color: #ffff; */
  /* box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%); */

  .current--{
    border: 3px solid #0264bf;
    span{
      background-color: #0264bf;
    }
  }

`
export const Progress = styled.div`
  display: flex;
  width: 95%;
  height: 6rem;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  border-radius: 4px;
  justify-content: space-between;
  background-color: #1D86FF;
  box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);

  .box--{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 0.5rem;

    .title--{
      font-size: 1rem;
      color:#ffffff;
      font-weight: bolder;
    }
  }
`
export const Icon = styled.div`
  display: flex; 
  width: 3rem; 
  height: 3rem; 
  border-radius: 50%; 
  padding: 0.2rem; 
  border: 3px solid #d3d3d3;
  cursor: pointer;

  span{ 
    display: flex;
    width: 100%; 
    height: 100%; 
    border-radius: 50%; 
    justify-content: center; 
    align-items: center; 
    background-color: #d3d3d3; 
    color: #ffffff; 
  }    

`
export const Main = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 1rem;
  flex-direction: column;
  gap: 0.5rem;
  /* box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%); */
  border-radius: 8px 8px 0 0;
  background-color: #f6f6f6;
  border: 1px solid #e8e8e8;

  .content{
    display: flex;
    width: 100%;
    height: 100%;
    gap: 1rem;
    .box--y{
      display: flex;
      width: 50%;
      max-height: 30rem;
      gap: 0.5rem;
      flex-direction: column;
      .add--{
        display: flex;
        justify-content: end;
        span{
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 0.2rem;
          cursor: pointer;
        }
      }
      .tag--{
        position: absolute;
        display: flex;
        width: 375px;
        justify-content: center;
        align-items: center;
        label{
          padding: 0 10px 0 10px;
          z-index: 9;
          background-color: #f6f6f6;
        }
      }
      .search--{
        padding: 0;
        height: 2.5rem;
      }
    }
  }

`
export const Options = styled.ul`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  overflow-y: auto;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
  li{
    display: flex;
    min-height: 4rem;
    flex-direction: row;
    list-style-type: none;
    padding: 0.5em;
    cursor: pointer;
    &:hover{
      background-color: #e8e8e8;
    }
    .avatar--{
      display: flex;
      height: 100%;
      width: 3rem;
      justify-content: center;
      align-items: center;
    }
    .avatar--list{
      display: flex;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      color: #ffffff;
      font-size: 1.5rem;
      justify-content: center;
      align-items: center;
      background-color: #1D86FF;
    }
    .info--{
      display: flex;
      width: calc(100% - 3rem);
      max-width: calc(100% - 3rem);
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      .name{
        display: flex;
        width: 100%;
        height: 50%;
        font-size: 1rem;
        font-weight: 500;
        color: black;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .description{
        display: flex;
        width: 100%;
        height: 50%;
        font-size: 1rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #eee;
      }
    }
  }
`
export const Selected = styled.ul`
  position: relative;
  display: flex;
  margin-top: 0.5rem;
  width: 100%;
  height: 100%;
  border: 1px solid #c2c2c2;
  border-radius: 4px;
  flex-direction: column;
  overflow-y: auto;
  padding: 1rem 0 0 0;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }
  li{
    display: flex;
    min-height: 4rem;
    flex-direction: row;
    list-style-type: none;
    padding: 0.5em;
    cursor: pointer;
    &:hover{
      background-color: #c2c2c2;
    }
    .avatar--{
      display: flex;
      height: 100%;
      width: 3rem;
      justify-content: center;
      align-items: center;
    }
    .avatar--list{
      display: flex;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      color: #ffffff;
      font-size: 1.5rem;
      justify-content: center;
      align-items: center;
      background-color: #1D86FF;
    }
    .info--{
      display: flex;
      width: calc(100% - 3rem);
      max-width: calc(100% - 3rem);
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      .name{
        display: flex;
        width: 100%;
        height: 50%;
        font-size: 1;
        font-weight: 500;
        color: black;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .description{
        display: flex;
        width: 100%;
        height: 50%;
        font-size: 1rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #eee;
      }
    }
    .icon{
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

`
export const SelectMessage = styled.div`
  display: flex;
  width: 100%;
  max-height: 100%;
  flex-direction: column;
  .preview--message{
    display: flex;
    width: 100%;
    max-height: 150px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    overflow-wrap: break-word;
    overflow: auto;
    border:2px solid #0264bf;
    padding: 1rem;
  }
  .box--message--{
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    margin-top: 1rem;
  }
  .message--{
    position: absolute;
    top: 0;
    left: 0;
    box-shadow: none;
    background-color: transparent;
    padding: 0;
  }

`
export const PreviewSend = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  gap: 0.5rem;

  .checkbox{
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    gap: 0.3rem;
    input{
      cursor: pointer;
    }
  }
  .message{
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    max-height: 100px;
    border-radius: 4px;
    padding: 1rem;
    overflow-wrap: break-word;
    overflow: auto;
    border:2px solid #0264bf;
  }
  .destiny{
    display: flex;
    width: 100%;
    height: 100%;
  }

`
export const LoadingSend = styled.div`
  display: flex;
  width: 100%;
  height:100%;
  justify-content: center;
  align-items: center;
  padding: 0 6rem 0 6rem;
  .icon--{
    color:#1D86FF;
    font-size: 6rem;
  }
  .area--pc--{
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  .area--msg--{
    display: flex;
    flex: 2;
    height: 100%;
    align-items: center;
    .icon--animation{
      font-size: 3rem;
      color: #0264bf;
      animation: slideright 1.5s linear infinite;
    }
  }
  .area--cel--{
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  @keyframes slideright {
    from {
      margin-left: 0%;
    }
    to {
      margin-left: 80%;
    }
}
`
export const Footer = styled.div`
  display: flex;
  width: 100%;
  flex:1;
  justify-content:space-between;
  align-items: end;
  background-color: #f6f6f6;
  padding: .5rem;
  /* box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%); */
  border-radius: 0 0 8px 8px;
  border: 1px solid #e8e8e8;
  margin-top: 5px;

  button{
    display: flex;
    border: none;
    height: 2.5rem;
    width: 6rem;
    gap: 1rem;
    padding: 1rem;
    font-size: 1.3rem;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: #1D86FF;
    border-radius:4px;
    color: #ffffff;
    font-size: 1rem;
    box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);
  }
  .send{
    background-color: #3498db;
  }
  .loader{
    display: flex;
    border: 2px solid #f3f3f3;
    border-radius: 50%;
    border-top: 2px solid #3498db;
    width: 2rem;
    height: 2rem;
    animation: spin 1.5s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .alert--red{
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    color: red;
    font-weight: bold;
  }
`